import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/win_3x/all_period?page=${currentPage || 1}&per_page=${perPage || 10}&name=${
      search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}`,
  );
};
